import { useEffect } from 'react';
import { LauncherElementType } from '../info/launcherElementInfo';
import { MouseData, useMouseStore } from './stores/mouseStore';

export const mouseCoreHooks = () => {
  const [mouseData, setMouseData] = useMouseStore<MouseData>();

  const handleMouseMove = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const hoveredLauncherElementType = target
      ? (target
          .closest('[launcher-element-type]')
          ?.getAttribute('launcher-element-type') as LauncherElementType)
      : null;

    const hoveredLauncherElementID:
      | LauncherElementType
      | 'handle'
      | 'scene'
      | null = target
      ? (() => {
          const element = target.closest('[launcher-element-id]');
          const id = element?.getAttribute(
            'launcher-element-id'
          ) as LauncherElementType | null;
          if (id !== null) {
            return id;
          }
          const closestHandleOrScene = target.closest('#handle, #scene');
          const fallbackId = closestHandleOrScene?.id;
          return fallbackId === 'handle' || fallbackId === 'scene'
            ? fallbackId
            : null;
        })()
      : null;

    const hoveredUIElement = target
      ? (target.closest('[ui-element]')?.getAttribute('ui-element') as string)
      : null;

    setMouseData({
      pos: { x: e.clientX, y: e.clientY },
      movement: { x: e.movementX, y: e.movementY },

      hoveredLauncherElementType,
      hoveredLauncherElementID,

      target: target,
      hoveredUIElement,

      isDragging: mouseData.isDown ? true : false,
      draggingDiff: mouseData.isDown
        ? {
            x: e.clientX - mouseData.draggingStartPos!.x,
            y: e.clientY - mouseData.draggingStartPos!.y,
          }
        : null,
    });
  };
  const handleMouseDown = (e: MouseEvent) => {
    setMouseData({
      isDown: true,
      button: e.button,
      draggingStartPos: { x: e.clientX, y: e.clientY },
    });
  };
  const handleMouseUp = (e: MouseEvent) =>
    setMouseData({
      isDown: false,
      button: e.button,
      draggingStartPos: null,
      draggingDiff: null,
    });

  const handleContextMenu = (e: MouseEvent) => {
    e.preventDefault();
  };

  const handleMouseWheel = (e: WheelEvent) => {
    if (e.ctrlKey) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('contextmenu', handleContextMenu);
    document
      .getElementById('root')
      ?.addEventListener('wheel', handleMouseWheel, true);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('contextmenu', handleContextMenu);
      document
        .getElementById('root')
        ?.removeEventListener('wheel', handleMouseWheel);
    };
  });
};
